import * as Yup from "yup";

export const WorkflowStatusOverrideSchema = Yup.object().shape({
    workflowStatusOverrides: Yup.array().of(
        Yup.object().shape({
            contractId: Yup.string().required(),
            ecaMapping: Yup.string().required(),
            ecaStatus: Yup.string().required(),
        }),
    ),
});